import { gql, useLazyQuery } from '@apollo/client'
import { Query } from '@promoboxx/graphql-gateway-types'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import ColoredChip from '../shared/ColoredChip'

export const GET_PENDING_INVITES = gql`
  query getPendingInvitesChip($userId: ID!) {
    getUser(id: $userId, fields: ["registration_keys"]) {
      id
      registration_keys {
        id
      }
    }
  }
`

const PendingInvitesChip: React.FC<React.PropsWithChildren> = (props) => {
  const currentUser = useSelector((state) => state.auth.user)
  const [runQuery, { data, loading }] = useLazyQuery<Query>(GET_PENDING_INVITES)

  useEffect(() => {
    runQuery({
      variables: {
        userId: currentUser.id,
      },
    })
  }, [currentUser.id, runQuery])

  const count = loading ? 0 : data?.getUser?.registration_keys?.length || 0

  if (count === 0) {
    return null
  }

  return <ColoredChip color="error" size="small" label={count} />
}

export default PendingInvitesChip
